import { gql } from '@apollo/client'
import React, { PropsWithChildren } from 'react'
import { ContactCTA as ContactCTABase } from '../components/contactcta/contactcta'
import { ContactCtaFragment } from './__generated__/contactCta'
import { GlobalLinksCtaFragment } from './__generated__/linksCtaFallback'

export type ContactCtaProps = {
  data: ContactCtaFragment[]
  fallback?: GlobalLinksCtaFragment
}

export const ContactCta: React.FC<PropsWithChildren<ContactCtaProps>> = ({ data, fallback }) => {
  if(data == undefined || data[0] == undefined ){
    return null
  }

  const contact = data[0]
  const fallbackCTA = fallback?.globalLinksCta?.[0]

  return ( contact.contactCtaTitle ? (
    <ContactCTABase>
      <ContactCTABase headingWrapper>
        <ContactCTABase title>{contact.contactCtaTitle}</ContactCTABase>
        <ContactCTABase subtitle>{contact.contactCtaSubtitle}</ContactCTABase>
      </ContactCTABase>
      <ContactCTABase contentWrapper>
        <ContactCTABase section type="wrapper" href={contact.contactCTALink1 || '#'}>
          {contact.contactCTAIcon1 && (
            <ContactCTABase icon variant={true} iconCode={contact.contactCTAIcon1}/>
          )}
          <ContactCTABase section type="content">
            <ContactCTABase title>{contact.contactCTATitle1}</ContactCTABase>
            <ContactCTABase subtitle>{contact.contactCTASubtitle1}</ContactCTABase>
          </ContactCTABase>
        </ContactCTABase>
        <ContactCTABase section type="wrapper" href={contact.contactCTALink2 || '#'}>
          {contact.contactCTAIcon2 && (
            <ContactCTABase icon variant={true} iconCode={contact.contactCTAIcon2}/>
          )}
          <ContactCTABase section type="content">
            <ContactCTABase title>{contact.contactCTATitle2}</ContactCTABase>
            <ContactCTABase subtitle>{contact.contactCTASubtitle2}</ContactCTABase>
          </ContactCTABase>
        </ContactCTABase>
        <ContactCTABase section type="wrapper" href={contact.contactCTALink3 || '#'}>
          {contact.contactCTAIcon3 && (
            <ContactCTABase icon variant={true} iconCode={contact.contactCTAIcon3}/>
          )}
          <ContactCTABase section type="content">
            <ContactCTABase title>{contact.contactCTATitle3}</ContactCTABase>
            <ContactCTABase subtitle>{contact.contactCTASubtitle3}</ContactCTABase>
          </ContactCTABase>
        </ContactCTABase>
        <ContactCTABase section type="wrapper" href={contact.contactCTALink4 || '#'}>
          {contact.contactCTAIcon4 && (
            <ContactCTABase icon variant={true} iconCode={contact.contactCTAIcon4}/>
          )}
          <ContactCTABase section type="content">
            <ContactCTABase title>{contact.contactCTATitle4}</ContactCTABase>
            <ContactCTABase subtitle>{contact.contactCTASubtitle4}</ContactCTABase>
          </ContactCTABase>
        </ContactCTABase>
      </ContactCTABase>
    </ContactCTABase>
  ): ((fallbackCTA && fallbackCTA.__typename === 'linksCta_BlockType') ? (
    <ContactCTABase>
      <ContactCTABase headingWrapper>
        <ContactCTABase title>{fallbackCTA?.linksCtaTitle}</ContactCTABase>
        <ContactCTABase subtitle>{fallbackCTA?.linksCtaSubtitle}</ContactCTABase>
      </ContactCTABase>
      <ContactCTABase contentWrapper>
        <ContactCTABase section type="wrapper" href={fallbackCTA?.linksCTALink1?.url || '#'}>
          {fallbackCTA?.linksCta1Icon && (
            <ContactCTABase icon variant={true} iconCode={fallbackCTA?.linksCta1Icon}/>
          )}
          <ContactCTABase section type="content">
            <ContactCTABase title>{fallbackCTA?.linksCTALink2?.customText}</ContactCTABase>
            <ContactCTABase subtitle>{fallbackCTA?.linksCta1Subtext}</ContactCTABase>
          </ContactCTABase>
        </ContactCTABase>
        <ContactCTABase section type="wrapper" href={fallbackCTA?.linksCTALink2?.url || '#'}>
          {fallbackCTA?.linksCta2Icon && (
            <ContactCTABase icon variant={true} iconCode={fallbackCTA?.linksCta2Icon}/>
          )}
          <ContactCTABase section type="content">
            <ContactCTABase title>{fallbackCTA?.linksCTALink2?.customText}</ContactCTABase>
            <ContactCTABase subtitle>{fallbackCTA?.linksCta2Subtext}</ContactCTABase>
          </ContactCTABase>
        </ContactCTABase>
        <ContactCTABase section type="wrapper" href={fallbackCTA?.linksCTALink3?.url || '#'}>
          {fallbackCTA?.linksCta3Icon && (
            <ContactCTABase icon variant={true} iconCode={fallbackCTA?.linksCta3Icon}/>
          )}
          <ContactCTABase section type="content">
            <ContactCTABase title>{fallbackCTA?.linksCTALink3?.customText}</ContactCTABase>
            <ContactCTABase subtitle>{fallbackCTA?.linksCta3Subtext}</ContactCTABase>
          </ContactCTABase>
        </ContactCTABase>
        <ContactCTABase section type="wrapper" href={fallbackCTA?.linksCTALink4?.url || '#'}>
          {fallbackCTA?.linksCta4Icon && (
            <ContactCTABase icon variant={true} iconCode={fallbackCTA?.linksCta4Icon}/>
          )}
          <ContactCTABase section type="content">
            <ContactCTABase title>{fallbackCTA?.linksCTALink4?.customText}</ContactCTABase>
            <ContactCTABase subtitle>{fallbackCTA?.linksCta4Subtext}</ContactCTABase>
          </ContactCTABase>
        </ContactCTABase>
      </ContactCTABase>
    </ContactCTABase>
  ) : null)
  )
}

export const CONTACT_CTA_FRAGMENT = gql`
  fragment ContactCtaFragment on contactCta_BlockType {
    id
    contactCtaTitle
    contactCtaSubtitle
    contactCTATitle1
    contactCTASubtitle1
    contactCTALink1
    contactCTAIcon1
    contactCTATitle2
    contactCTASubtitle2
    contactCTALink2
    contactCTAIcon2
    contactCTATitle3
    contactCTASubtitle3
    contactCTALink3
    contactCTAIcon3
    contactCTATitle4
    contactCTASubtitle4
    contactCTALink4
    contactCTAIcon4
  }
`
